"use strict";

exports.__esModule = true;
exports.v2PathRegex = void 0;
var v2PathRegex = exports.v2PathRegex = /\/internal.*\/v2/;
//# sourceMappingURL=commons.js.map